import {Participant, PlanExercise} from "../../../../../types/domain";
import {jsPDF} from "jspdf";
import autoTable from "jspdf-autotable";
import {getAttachmentPaths, getFileNameFromPath, getUniqueFilename} from "../helperFunctions";
import FtpService from "../../../../../services/ftp.service";

/**
 * Helper function to export exercises in pdf
 * @param planDate date of the plan
 * @param exercises list with the exercises
 * @param name name of the group or the participant
 * @param participants list of participants if it is a single training
 * @param topic topic of the training
 * @author KMU
 */
export async function exportExerciseList(planDate: string, exercises: Array<PlanExercise>,
                                         name: string, participants: Array<Participant> | undefined,
                                         topic: string) {
    const doc = new jsPDF({orientation: 'landscape'});
    const totalPagesExp = '{total_pages_count_string}';

    let body = [];
    const usedNames = new Set<string>();
    const counts = new Map<string, number>();

    const attachmentPaths = getAttachmentPaths(exercises);

    const response = await FtpService.getPageCount(attachmentPaths);
    const pageCounts = new Map(Object.entries(response.data));

    //build exercise list
    for (let i in exercises.sort((a: PlanExercise, b: PlanExercise) => a.position! - b.position!)) {
        let mergedPages = "";
        let singlePages = "";
        exercises[i].attachments.forEach(a => {
            if (pageCounts.has(a.path)) {
                mergedPages += pageCounts.get(a.path) +", ";
            } else {
                const uniqueFilename = getUniqueFilename(getFileNameFromPath(a.path), usedNames, counts);
                usedNames.add(uniqueFilename);
                singlePages += uniqueFilename +", ";
            }
            if (a.solutionPath != '') {
                if (pageCounts.has(a.solutionPath)) {
                    mergedPages += pageCounts.get(a.solutionPath)+", ";
                } else {
                    const uniqueFilename = getUniqueFilename(getFileNameFromPath(a.solutionPath), usedNames, counts);
                    usedNames.add(uniqueFilename);
                    singlePages += uniqueFilename +", ";
                }
            }
        })

        let allFiles = '';
        if (singlePages != '')
            allFiles = singlePages
        if (mergedPages != ''){
            allFiles = [allFiles, mergedPages].join("Anhaenge.pdf Seite ")
        }
        // remove the last ", "
        allFiles = allFiles.substring(0, allFiles.length-2);

        body.push([exercises[i].exercise.name, exercises[i].exercise.description,
            exercises[i].exercise.methods.map(m => m.code).join(', '),
            exercises[i].exercise.material,
            allFiles
        ])
    }

    //build table for pdf
    autoTable(doc, {
        head: [['Übung/Tätigkeit', 'Beschreibung', 'Methode', 'Material', 'Anhänge', 'durchgeführt']],
        body: body,
        willDrawPage: function (data) {
            // Header
            doc.setFontSize(20)
            doc.setTextColor(40)
            doc.text('Übungsliste für ' + name + ' am ' +
                new Intl.DateTimeFormat('de-DE', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }).format(new Date(planDate)),
                15, 22)
        },
        didDrawPage: function (data) {
            // Footer
            var str = 'Seite ' + doc.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' von ' + totalPagesExp
            }
            doc.setFontSize(10)

            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        margin: {top: 30}
    })

    //set total page number
    if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages('{total_pages_count_string}')
    }

    //export pdf
    doc.save('Übungsliste_' + name + "_" + new Date(planDate)
        .toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: 'numeric'})
        .replace(/\./g, '_') + '.pdf')
}